import {Dialog, Typography} from "@material-tailwind/react";
import React, {useEffect, useState} from "react";
import {ReservationBranchAndTimeForm} from "./reservation_form";
import {InvoiceForm} from "./invoice_form";
import {submitUserReservation} from "../../services/reservation/reservation";
import {ChargeWalletForm} from "./charge_wallet_form";
import {getConsultationAgentBranchFee} from "../../services/agent_branch_fee/agent_branch_fee";
import {Toaster} from "../../helper/Toaster";
import {submitBackOfficeReservation} from "../../services/back_office/reservation";

export function ReservationForm({
                                  event,
                                  open,
                                  setOpen,
                                  onSave,
                                  date,
                                  setLastDataRefresh,
                                  payedReservation,
                                  agent_id,
                                  branch_id,
                                  person_id,
                                }) {
  const handleOpen = () => setOpen(!open);

  const [id, setId] = useState(null);
  const [agentId, setAgentId] = useState(agent_id || null);
  const [title, setTitle] = useState("");
  const [userStartTime, setUserStartTime] = useState(0);
  const [scheduleStartDate, setScheduleStartDate] = useState("00:00:00");
  const [scheduleEndDate, setScheduleEndDate] = useState("00:00:00");
  const [minute, setMinute] = useState(15);
  const [jalaliDate, setJalaliDate] = useState("");

  const [step, setStep] = useState(1);

  const [branchVatPercentage, setBranchVatPercentage] = useState(0);
  const [consultationPrice, setConsultationPrice] = useState(0);

  const [branchId, setBranchId] = useState(branch_id || null);

  const [chargeAmount, setChargeAmount] = useState(0)
  const [chargeDiscountCode, setChargeDiscountCode] = useState(null);

  const [challenge, setChallenge] = useState("");
  const [topic, setTopic] = useState(null);

  const [buttonLoading, setButtonLoading] = useState(false);

  const [personId, setPersonId] = useState(person_id)

  useEffect(() => {
    if (localStorage.getItem('branchId')) {
      setBranchId(localStorage.getItem('branchId'));
      localStorage.removeItem('branchId');
    }

    if (payedReservation) {
      setAgentId(payedReservation.agentId);
      setBranchId(payedReservation.branchId);
      setUserStartTime(payedReservation.userStartTime);
      setMinute(payedReservation.minute);
      setJalaliDate(payedReservation.jalaliDate);
      setStep(2)
      setChargeDiscountCode(payedReservation.discountCode);

      async function getData(branchId, agentId) {
        const result = await getConsultationAgentBranchFee(branchId, agentId);
        if (result.status === 200) {
          const {agent_branch_fee_and_vat} = result.data;
          setConsultationPrice(agent_branch_fee_and_vat?.price * minute ?? 0);
          setBranchVatPercentage(agent_branch_fee_and_vat?.vat_percentage ?? 0);
        }
      }

      if (branchId && agentId !== null && agentId !== undefined) {
        getData(branchId, agentId)
      }
    } else {
      setId(event?.events?.[0]?.id ?? null);
      setAgentId(event?.events?.[0]?.agent_id ?? null);
      setTitle(event?.events?.[0]?.title ?? null);
      setJalaliDate(event?.jalaliDate ?? "");
      setScheduleStartDate(event?.events?.[0]?.from ?? null)
      setScheduleEndDate(event?.events?.[0]?.to ?? null)
    }

  }, [event]);

  const save_reserve = async (consultationPriceAfterDiscount, consultationVat, discountCode, personId) => {
    if (!branchId) {
      Toaster.failure(null, <Typography variant={"small"}>
        انتخاب گرایش اجباری است.
      </Typography>);
      return
    }
    
    const data = {
      agent_id: agentId,
      schedule_id: id,
      branch_id: parseInt(branchId),
      date: jalaliDate,
      start_time: userStartTime,
      minute: parseInt(minute),
      consultation_price: consultationPriceAfterDiscount,
      consultation_vat: consultationVat,
      topic: topic,
      challenge: challenge,
    }
    if (discountCode) {
      data.discount_code = discountCode;
    } else {
      data.discount_code = "_"
    }
    
    try {
      setButtonLoading(true);
      let result;

      if (!personId) {
        result = await submitUserReservation(data)
      } else {
        data.person_id = personId;
        result = await submitBackOfficeReservation(data)
      }

      if (result.status === 200) {
        const {reservation} = result.data;
        setLastDataRefresh(Date.now())
        setOpen(false);
        if (personId) {
          localStorage.setItem("lastClicked", "user_reservation")
          window.location.reload();
        }
      } else {
        Toaster.failure(null, <Typography variant={"small"}>
          {result.data?.message || 'خطا در ثبت رزرو'}
        </Typography>);
      }
    } catch (err) {
      Toaster.failure(null, <Typography variant={"small"}>
        {err.message || 'خطا در ثبت رزرو'}
      </Typography>);
      console.error('Reservation save error:', err);
    } finally {
      setButtonLoading(false);
    }
  }

  return (
    <>
      <Dialog size="md" className="overflow-hidden" open={open} handler={handleOpen}
              animate={{mount: {scale: 1, y: 0}, unmount: {scale: 0.9, y: -100}}}>
        <>
          {step === 1 &&
            <ReservationBranchAndTimeForm
              branch_id={branchId}
              event={event}
              step={step}
              setStep={setStep}
              currentAgentId={agentId}
              open={open}
              setOpen={handleOpen}
              currentBranchId={branchId}
              currentMinute={minute}
              scheduleStartTime={scheduleStartDate}
              scheduleEndTime={scheduleEndDate}
              onSave={(agentId, branchFee, branchVatPercentage, consultationPrice, branchId, userStartTime, minute, topic, challenge) => {
                setBranchVatPercentage(branchVatPercentage);
                setConsultationPrice(consultationPrice);
                setBranchId(branchId);
                setUserStartTime(userStartTime);
                setMinute(minute)
                setStep(2);
                setTopic(topic);
                setChallenge(challenge);
              }}/>
          }
          {step === 2 &&
            <InvoiceForm currentAgentId={agentId}
                         branchVatPercentage={branchVatPercentage}
                         price={consultationPrice}
                         setStep={setStep}
                         branchId={branchId}
                         agentId={agentId}
                         personId={personId}
                         setChargeAmount={setChargeAmount}
                         setChargeDiscountCode={setChargeDiscountCode}
                         chargeDiscountCode={chargeDiscountCode}
                         onSave={(consultationPriceAfterDiscount, consultationVat, discountCode, tag, personId) => {
                           save_reserve(consultationPriceAfterDiscount, consultationVat, discountCode, personId)
                         }}
                         buttonLoading={buttonLoading}
            />
          }
          {step === 3 &&
            <ChargeWalletForm
              chargeAmount={chargeAmount}
              setChargeAmount={setChargeAmount}
              setStep={setStep}
              modalOpen={open}
              setModalOpen={setOpen}
              chargeDiscountCode={chargeDiscountCode}
              agentId={agentId}
              branchId={branchId}
              userStartTime={userStartTime}
              minute={minute}
              scheduleId={id}
              jalaliDate={jalaliDate}
            />
          }
        </>
      </Dialog>
    </>
  )
    ;
}
